import PropTypes from "prop-types";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import useAuth from "src/hooks/useAuth";
import { PATH_DASHBOARD, PATH_HUB } from "src/routes/paths";
import { initiateSSOToApp } from "src/utils/sso";

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard() {
  const { isAuthenticated, isAdmin, isSubAdmin } = useAuth();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');

  console.log('[GuestGuard] Render - isAuthenticated:', isAuthenticated);
  console.log('[GuestGuard] Current URL:', window.location.href);
  console.log('[GuestGuard] returnUrl from searchParams:', returnUrl);
  console.log('[GuestGuard] searchParams toString:', searchParams.toString());

  // Handle SSO redirect when user is authenticated with returnUrl
  useEffect(() => {
    if (isAuthenticated && returnUrl) {
      console.log('[GuestGuard] User authenticated WITH returnUrl - initiating SSO');
      const appUrl = process.env.REACT_APP_APP_URL || 'http://app.summus_network.localhost';
      const isSSOLink = returnUrl === appUrl || returnUrl.startsWith(appUrl);

      if (isSSOLink) {
        console.log('[GuestGuard] SSO link detected - initiating SSO to App');
        initiateSSOToApp(returnUrl);
      } else {
        console.log('[GuestGuard] External URL - redirecting directly');
        window.location.href = returnUrl;
      }
    }
  }, [isAuthenticated, returnUrl]);

  if (isAuthenticated && !returnUrl) {
    // Admin/SubAdmin go directly to Network dashboard
    if (isAdmin || isSubAdmin) {
      console.log('[GuestGuard] Admin/SubAdmin - Redirecting to dashboard');
      return <Navigate to={PATH_DASHBOARD.root} />;
    }
    // Regular users go to hub to choose
    console.log('[GuestGuard] Redirecting to hub (no returnUrl)');
    return <Navigate to={PATH_HUB.root} />;
  }

  // If authenticated with returnUrl, useEffect will handle redirect
  // Show nothing while redirecting
  if (isAuthenticated && returnUrl) {
    return null;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
